import MeasureCategory from './MeasureCategory';

export default MeasureCategory;
